import { type ReactNode } from "react";

import { NavigationFeatureFlagsContext } from "@/context/navigation-feature-flags-context";

// TODO: Replace any of these with useFlag(Flags.X) once the feature is
// implemented and needs to be controlled via Kinde. Currently none of these
// features are on the upcoming roadmap.
const NAVIGATION_FLAGS = {
	enableAnalytics: false,
	enableCaseManagement: false,
	enableSopManagement: false,
} as const;

export const NavigationFeatureFlagsProvider = ({
	children,
}: {
	children: ReactNode;
}) => (
	<NavigationFeatureFlagsContext.Provider value={NAVIGATION_FLAGS}>
		{children}
	</NavigationFeatureFlagsContext.Provider>
);
